/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialQqGroupinfoRequest = { group_id: string };

export const GetSocialQqGroupinfoRequest$zodSchema: z.ZodType<
  GetSocialQqGroupinfoRequest
> = z.object({
  group_id: z.string().describe("QQ群号，长度5-12位"),
});

/**
 * QQ群不存在或无法访问（经优化后，此接口遵循RESTful规范，群不存在时返回404而非500）
 */
export type GetSocialQqGroupinfoNotFoundResponseBody = {
  error?: string | undefined;
};

export const GetSocialQqGroupinfoNotFoundResponseBody$zodSchema: z.ZodType<
  GetSocialQqGroupinfoNotFoundResponseBody
> = z.object({
  error: z.string().optional(),
}).describe(
  "QQ群不存在或无法访问（经优化后，此接口遵循RESTful规范，群不存在时返回404而非500）",
);

export type GetSocialQqGroupinfoDetails = {};

export const GetSocialQqGroupinfoDetails$zodSchema: z.ZodType<
  GetSocialQqGroupinfoDetails
> = z.object({});

/**
 * 缺少或无效的group_id参数
 */
export type GetSocialQqGroupinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetSocialQqGroupinfoDetails | undefined;
  message?: string | undefined;
};

export const GetSocialQqGroupinfoBadRequestResponseBody$zodSchema: z.ZodType<
  GetSocialQqGroupinfoBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetSocialQqGroupinfoDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("缺少或无效的group_id参数");

/**
 * 成功响应，返回QQ群的详细信息
 */
export type GetSocialQqGroupinfoResponseBody = {
  group_id?: string | undefined;
  group_name?: string | undefined;
  avatar_url?: string | undefined;
  description?: string | undefined;
  tag?: string | undefined;
  join_url?: string | undefined;
  last_updated?: string | undefined;
  member_count?: number | undefined;
  max_member_count?: number | undefined;
  active_member_num?: number | undefined;
  owner_uin?: string | undefined;
  owner_uid?: string | undefined;
  create_time?: number | undefined;
  create_time_str?: string | undefined;
  group_grade?: number | undefined;
  group_memo?: string | undefined;
  cert_type?: number | undefined;
  cert_text?: string | undefined;
};

export const GetSocialQqGroupinfoResponseBody$zodSchema: z.ZodType<
  GetSocialQqGroupinfoResponseBody
> = z.object({
  active_member_num: z.int().optional(),
  avatar_url: z.string().optional(),
  cert_text: z.string().optional(),
  cert_type: z.int().optional(),
  create_time: z.int().optional(),
  create_time_str: z.string().optional(),
  description: z.string().optional(),
  group_grade: z.int().optional(),
  group_id: z.string().optional(),
  group_memo: z.string().optional(),
  group_name: z.string().optional(),
  join_url: z.string().optional(),
  last_updated: z.string().optional(),
  max_member_count: z.int().optional(),
  member_count: z.int().optional(),
  owner_uid: z.string().optional(),
  owner_uin: z.string().optional(),
  tag: z.string().optional(),
}).describe("成功响应，返回QQ群的详细信息");

export type GetSocialQqGroupinfoResponse =
  | GetSocialQqGroupinfoResponseBody
  | GetSocialQqGroupinfoBadRequestResponseBody
  | GetSocialQqGroupinfoNotFoundResponseBody;

export const GetSocialQqGroupinfoResponse$zodSchema: z.ZodType<
  GetSocialQqGroupinfoResponse
> = z.union([
  z.lazy(() => GetSocialQqGroupinfoResponseBody$zodSchema),
  z.lazy(() => GetSocialQqGroupinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetSocialQqGroupinfoNotFoundResponseBody$zodSchema),
]);
